<template>
  <div :class="`as-goals-scored`">
    <div class="as-goals-scored__head">
      <IconCorner />
      <span> Phạt góc đội </span>
    </div>
    <div class="as-history">
      <div class="as-history-item">
        <div class="as-history-item__head">
          <div
            class="as-head-tab"
            :class="{ 'as-active': activeTab === 'all' }"
            @click="setActiveTab('all')"
          >
            Cả trận
          </div>
          <div
            class="as-head-tab"
            :class="{ 'as-active': activeTab === 'half' }"
            @click="setActiveTab('half')"
          >
            Hiệp 1/2
          </div>
        </div>
        <div class="as-history-item__body" v-if="activeTab === 'all'">
          <div class="as-competition">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>PG kiếm được</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">Trung bình</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr>
                                    <td>Kiếm được/Trận</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_earned_1h_avg_overall'))}`">{{ getValueWithMode('home', 'corners_earned_1h_avg_overall') }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_earned_1h_avg_overall'))}`">{{ getValueWithMode('away', 'corners_earned_1h_avg_overall') }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over85Corners_overall'))}`">{{ calculatorAVG(getValueWithMode('home', 'corners_earned_1h_avg_overall'), getValueWithMode('away', 'corners_earned_1h_avg_overall')) }}%</td>
                                </tr> -->
                <tr>
                  <td>Trên 2.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'home',
                        'over25CornersForPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "home",
                        "over25CornersForPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over25CornersForPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "away",
                        "over25CornersForPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over25CornersForPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over25CornersForPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Trên 3.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'home',
                        'over35CornersForPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "home",
                        "over35CornersForPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over35CornersForPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "away",
                        "over35CornersForPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over35CornersForPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over35CornersForPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Trên 4.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'home',
                        'over45CornersForPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "home",
                        "over45CornersForPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over45CornersForPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "away",
                        "over45CornersForPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over45CornersForPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over45CornersForPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Trên 5.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'home',
                        'over55CornersForPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "home",
                        "over55CornersForPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over55CornersForPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "away",
                        "over55CornersForPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over55CornersForPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over55CornersForPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="as-competition">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>PG chống lại</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">Trung bình</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr>
                                    <td>Phải chiu/Trận</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'cornersAgainstAVG_overall'))}`">{{ getValueWithMode('home', 'cornersAgainstAVG_overall') }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'cornersAgainstAVG_overall'))}`">{{ getValueWithMode('away', 'cornersAgainstAVG_overall') }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over85Corners_overall'))}`">{{ calculatorAVG(getValueWithMode('home', 'cornersAgainstAVG_overall'), getValueWithMode('away', 'cornersAgainstAVG_overall')) }}%</td>
                                </tr> -->
                <tr>
                  <td>Trên 2.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'home',
                        'over25CornersAgainstPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "home",
                        "over25CornersAgainstPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over25CornersAgainstPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "away",
                        "over25CornersAgainstPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over25CornersAgainstPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over25CornersAgainstPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Trên 3.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'home',
                        'over35CornersAgainstPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "home",
                        "over35CornersAgainstPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over35CornersAgainstPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "away",
                        "over35CornersAgainstPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over35CornersAgainstPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over35CornersAgainstPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Trên 4.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over45CornersAgainstPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "home",
                        "over45CornersAgainstPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over45CornersAgainstPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "away",
                        "over45CornersAgainstPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over45CornersAgainstPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over45CornersAgainstPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>Trên 5.5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'home',
                        'over55CornersAgainstPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "home",
                        "over55CornersAgainstPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode(
                        'away',
                        'over55CornersAgainstPercentage_overall'
                      )
                    )}`"
                  >
                    {{
                      getValueWithMode(
                        "away",
                        "over55CornersAgainstPercentage_overall"
                      )
                    }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over55CornersAgainstPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over55CornersAgainstPercentage_overall"
                        )
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="as-history-item__body" v-if="activeTab === 'half'">
          <div class="as-competition" v-if="activeTab === 'half'">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>First Half</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">Trung bình</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>FH Average</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'corners_2h_avg_overall')
                    )}`"
                  >
                    {{ getValueWithMode("home", "corners_2h_avg_overall") }}
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('away', 'corners_2h_avg_overall')
                    )}`"
                  >
                    {{ getValueWithMode("away", "corners_2h_avg_overall") }}
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_avg_overall'),
                        getValueWithMode('away', 'corners_2h_avg_overall')
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "corners_2h_avg_overall"),
                        getValueWithMode("away", "corners_2h_avg_overall")
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>FH Over 4</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'corners_fh_over4_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("home", "corners_fh_over4_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('away', 'corners_fh_over4_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("away", "corners_fh_over4_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_fh_over4_percentage_overall'),
                        getValueWithMode('away', 'corners_fh_over4_percentage_overall')
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "corners_fh_over4_percentage_overall"),
                        getValueWithMode("away", "corners_fh_over4_percentage_overall")
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>FH Over 5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'corners_fh_over5_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("home", "corners_fh_over5_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('away', 'corners_fh_over5_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("away", "corners_fh_over5_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_fh_over5_percentage_overall'),
                        getValueWithMode('away', 'corners_fh_over5_percentage_overall')
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "corners_fh_over5_percentage_overall"),
                        getValueWithMode("away", "corners_fh_over5_percentage_overall")
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>FH Over 6</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'corners_fh_over6_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("home", "corners_fh_over6_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('away', 'corners_fh_over6_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("away", "corners_fh_over6_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_fh_over6_percentage_overall'),
                        getValueWithMode('away', 'corners_fh_over6_percentage_overall')
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "corners_fh_over6_percentage_overall"),
                        getValueWithMode("away", "corners_fh_over6_percentage_overall")
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>Second Half</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">Trung bình</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>FH Average</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'corners_2h_avg_overall')
                    )}`"
                  >
                    {{ getValueWithMode("home", "corners_2h_avg_overall") }}
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('away', 'corners_2h_avg_overall')
                    )}`"
                  >
                    {{ getValueWithMode("away", "corners_2h_avg_overall") }}
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_avg_overall'),
                        getValueWithMode('away', 'corners_2h_avg_overall')
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "corners_2h_avg_overall"),
                        getValueWithMode("away", "corners_2h_avg_overall")
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>FH Over 4</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'corners_2h_over4_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("home", "corners_2h_over4_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('away', 'corners_2h_over4_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("away", "corners_2h_over4_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_over4_percentage_overall'),
                        getValueWithMode('away', 'corners_2h_over4_percentage_overall')
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "corners_2h_over4_percentage_overall"),
                        getValueWithMode("away", "corners_2h_over4_percentage_overall")
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>FH Over 5</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'corners_2h_over5_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("home", "corners_2h_over5_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('away', 'corners_2h_over5_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("away", "corners_2h_over5_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_over5_percentage_overall'),
                        getValueWithMode('away', 'corners_2h_over5_percentage_overall')
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "corners_2h_over5_percentage_overall"),
                        getValueWithMode("away", "corners_2h_over5_percentage_overall")
                      )
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>FH Over 6</td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('home', 'corners_2h_over6_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("home", "corners_2h_over6_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      getValueWithMode('away', 'corners_2h_over6_percentage_overall')
                    )}`"
                  >
                    {{ getValueWithMode("away", "corners_2h_over6_percentage_overall") }}%
                  </td>
                  <td
                    :class="`as-center ${getClassForItem(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_over6_percentage_overall'),
                        getValueWithMode('away', 'corners_2h_over6_percentage_overall')
                      )
                    )}`"
                  >
                    {{
                      calculatorAVG(
                        getValueWithMode("home", "corners_2h_over6_percentage_overall"),
                        getValueWithMode("away", "corners_2h_over6_percentage_overall")
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import IconCorner from "~src/components/icons/foot_stats/IconCorner.vue";
import type { IMatch } from "~src/interfaces";
import type {
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { ref, computed } from "vue";
import { getClassForItem } from "~src/helpers/footystats";

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}

const props = withDefaults(defineProps<Props>(), {
  mode: "as-win",
});

const activeTab = ref("all");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const getValueWithMode = (team = "home", mode = "btts", mode_half = "") => {
  const __data: IStatsParent =
    team === "home" ? homeTeamLastX.value : awayTeamLastX.value;
  let __mode = mode;
  if (mode_half) {
    __mode = mode_half;
  }
  if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
    return 0;
  }

  return __data.stats[__mode] as number;
};

const calculatorAVG = (home: number, away: number) => {
  const _avg = (home + away) / 2;

  return Math.round(_avg);
};
</script>

<script lang="ts">
export default {};
</script>
